import styled, { CSSObject } from 'styled-components';
import { Variant, Size } from './types';

interface IconButtonStyledProps {
  mr?: number;
  size: keyof typeof Size;
  variant?: keyof typeof Variant;
  rounded?: boolean;
  disabled?: boolean;
}

const IconButtonStyled = styled.div<IconButtonStyledProps>(
  ({ theme, mr, size, variant, rounded, disabled }) => {
    let styleSheet: CSSObject = {
      marginRight: theme.space[mr],
      cursor: 'pointer',
      boxSizing: 'border-box',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: theme.space[8], // 32px
      height: theme.space[8], // 32px
      background: theme.color.primary,
      borderRadius: 4,
      transition: 'background 0.2s linear',
      '&:hover': {
        background: theme.color.wfBlue800,
      },
    };

    if (size === Size.small) {
      styleSheet.width = theme.space[6]; // 24px
      styleSheet.height = theme.space[6]; // 24px
    }

    if (variant === Variant.plain) {
      styleSheet = {
        ...styleSheet,
        background: 'transparent',
        '&:hover': {
          background: theme.color.wfGrey200,
        },
      };
    }

    if (variant === Variant.outlined) {
      styleSheet = {
        ...styleSheet,
        border: `1px solid ${theme.color.wfBlack}`,
        background: 'transparent',
        '&:hover': {
          background: theme.color.wfGrey200,
        },
      };
    }

    if (rounded) {
      styleSheet.borderRadius = 9999;
    }

    if (disabled) {
      styleSheet = {
        ...styleSheet,
        opacity: 0.5,
        pointerEvents: 'none',
        userSelect: 'none',
      };
    }

    return styleSheet;
  },
);

export { IconButtonStyled };
